<template>
  <div id="app">

    <rxmenu/>

    <div class="content">
      <keep-alive>
        <router-view/>
      </keep-alive>
    </div>

    <rxfooter/>

    <modal v-if="showvideo" @close="closevideo">
      <template v-slot:header>Watch video</template>
        <template v-slot:body>
          
            <vimeo-player video-id='404253625' :player-width="pwh.w" :player-height="pwh.h"></vimeo-player>
        
        </template>
      <template v-slot:footer></template>
      
    </modal>

    <signupnews v-if="showsignupnews && !signupnews" @close="closesignupnews"/>

  </div>

</template>

<script>

import rxfooter from '@/components/rx/footer/index.vue'
import rxmenu from '@/components/rx/menu/index.vue'
import signupnews from '@/components/assets/signupnews/index.vue'


export default {
  components: {
    rxfooter,
    rxmenu,
    signupnews
  },

  data : function(){
    return {
      showsignupnews : true,
      showvideo : false
    }
  },

  computed : {
    pwh : function(){
      var w = 800;
      var k = 2

      if(w > window.innerWidth){
         w = window.innerWidth
      }

      var h = w / k
    
      return {
        w : w,
        h : h
      }
    },

    signupnews : function(){
      return localStorage['signupnews']
    }
  },
  methods : {
    closevideo : function(){
      this.showvideo = false
    },
    closesignupnews : function(){
      this.showsignupnews = false
    }
  }
}

</script>

<style lang="sass" src="./index.sass"></style>


